// extracted by mini-css-extract-plugin
export default {"form_grid":"index-module__form_grid--fPwFx"};